import React, { Suspense } from 'react';
import { observer } from 'mobx-react';
import loadable from '@loadable/component';
import { Loadable } from 'components/Loadable';

import { Route, Switch } from 'react-router-dom';
import * as paths from 'Paths';


const AccountsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/accounts/accounts" */
    'routes/Accounts/AccountsRoute'
  )
));

const UpdateAccountRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/accounts/update-account" */
    'routes/Accounts/UpdateAccountRoute'
  )
));

const MembersRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/accounts/members" */
    'routes/Accounts/MembersRoute'
  )
));

const ApiDetailsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/accounts/api-details" */
    'routes/Accounts/ApiDetailsRoute'
  )
));

const WebhooksRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/accounts/webhooks" */
    'routes/Accounts/WebhooksRoute'
  )
));

const UpdateWebhookRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/accounts/update-webhook" */
    'routes/Accounts/UpdateWebhookRoute'
  )
));


const getAccountsRoutes = () => {
  return [
    {path: paths.getPathAccounts(), component: AccountsRoute},
    {path: paths.getPathAddAccount(), component: UpdateAccountRoute},
    {path: paths.getPathEditAccount(":accountId"), component: UpdateAccountRoute},
    {path: paths.getPathAccountMembers(":accountId"), component: MembersRoute},
    {path: paths.getPathApiDetails(), component: ApiDetailsRoute},

    {path: paths.getPathWebhooks(), component: WebhooksRoute},
    {path: paths.getPathAddWebhook(), component: UpdateWebhookRoute},
    {path: paths.getPathEditWebhook(":webhookId"), component: UpdateWebhookRoute},
  ]
}



export { getAccountsRoutes };
